import styled from "styled-components";

export const Overlay = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.4);
  z-index: 1500;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const ModalContainer = styled.div`
  background: white;
  border-radius: 12px;
  width: 450px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.15);
`;

export const ModalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 20px;
 // border-bottom: 1px solid #eee;
`;

export const ModalTitle = styled.h3`
  font-size: 16px;
  font-weight: 600;
  margin: 0;
`;

export const CloseIcon = styled.span`
  font-size: 20px;
  cursor: pointer;
  color: #888;
`;

export const ModalContent = styled.div`
  padding: 0px 20px 0px 20px;
  border-bottom: 1px solid #eee;
`;

export const ModalText = styled.p`
  font-family: 'Manrope', sans-serif;
font-weight: 500;
font-size: 14px;
leading-trim: Cap height;
line-height: 22px;
letter-spacing: 0%;
color:#48566B;
`;

export const ButtonGroup = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 17px;
  margin-bottom: 19px;
  margin-right: 24px;
  gap: 12px;
`;

export const CancelButton = styled.button`
  font-family: 'Manrope', sans-serif;
font-weight: 600;
font-size: 13px;
leading-trim: Cap height;
line-height: 100%;
letter-spacing: 0%;
vertical-align: middle;
    min-width: 68px;
height: 32px;
border-radius: 6px;
border-width: 1px;
gap: 10px;
padding-top: 10px;
padding-right: 12px;
padding-bottom: 10px;
padding-left: 12px;
border:none;
color:#1B2028;
cursor: pointer;
  &:disabled {
    opacity: 0.45;
    cursor: not-allowed;
  }
`;

export const ConfirmButton = styled.button`
   font-family: 'Manrope', sans-serif;
font-weight: 600;
font-size: 13px;
leading-trim: Cap height;
line-height: 100%;
letter-spacing: 0%;
vertical-align: middle;
    min-width: 88px;
height: 32px;
border-radius: 6px;
border-width: 1px;
gap: 10px;
padding-top: 10px;
padding-right: 12px;
padding-bottom: 10px;
padding-left: 12px;
border:none;
background:#0C53BB;
color:#FFFFFF;
cursor: pointer;
  &:hover:not(:disabled) {
    background: #003d99;
  }
  &:disabled {
    opacity: 0.75;
    cursor: not-allowed;
  }
`;
 